import { Box, Button } from '@mui/material'
import { Fragment, useContext, useEffect, useMemo, useState } from 'react'

import useGetSurchargePercentage from '../../../hooks/useGetSurchargePercentage/useGetSurchargePercentage'
import { CounterSalesContext } from '../../../providers/CounterSalesProvider/CounterSalesProvider'
import { RepairPaymentInfoCachedFinixTransferStatusEnum } from '../../../sdk'
import { roundToTwoDecimal } from '../../../utils/roundToTwoDecimal/roundToTwoDecimal'
import { usePaymentDialog } from '../../Estimates/RepairOrderPayment/PaymentDialog'
import { getDueTotalFromPayments } from '../../RepairOrder/getDueTotalFromPayments'

interface Props {
  handleBack: () => void
  handleNext: () => void
  openFinixDialog: boolean
  setOpenFinixDialog: (openDialog: boolean) => void
}

const CounterSalePayment = ({
  handleBack,
  handleNext,
  openFinixDialog,
  setOpenFinixDialog
}: Props) => {
  const { activeCounterSale } = useContext(CounterSalesContext)
  const { surchargePercentage } = useGetSurchargePercentage(
    activeCounterSale?.entry?.info?.taxesAndFees
  )

  const { setCustomProps: setPaymentProps, PaymentDialogUI } =
    usePaymentDialog()

  useEffect(() => {
    if (activeCounterSale?.entry?.id) {
      setPaymentProps({
        repairOrderId: undefined,
        counterSaleId: activeCounterSale.entry.id
      })
    }
  }, [activeCounterSale?.entry?.id, setPaymentProps])

  const [isSubmittingCardPresent, setIsSubmittingCardPresent] = useState('')

  useEffect(() => {
    if (isSubmittingCardPresent !== '' && isSubmittingCardPresent !== '-1') {
      const payment = activeCounterSale?.pricing?.payments?.find(
        (p) => p.id === isSubmittingCardPresent
      )
      if (
        payment?.info?.cachedFinixTransferStatus ===
        RepairPaymentInfoCachedFinixTransferStatusEnum.Succeeded
      ) {
        setIsSubmittingCardPresent('1')
      }
      if (
        payment?.info?.cachedFinixTransferStatus !== undefined &&
        payment?.info?.cachedFinixTransferStatus !==
          RepairPaymentInfoCachedFinixTransferStatusEnum.Succeeded
      ) {
        setIsSubmittingCardPresent('-1')
      }
    }
  }, [isSubmittingCardPresent, activeCounterSale?.pricing?.payments])

  const dueTotal = useMemo(
    () =>
      getDueTotalFromPayments(
        activeCounterSale?.pricing?.payments,
        activeCounterSale?.pricing?.totalBeforeSurcharge
      ) || 0,
    [
      activeCounterSale?.pricing?.payments,
      activeCounterSale?.pricing?.totalBeforeSurcharge
    ]
  )

  const dueTotalWithSurcharge = useMemo(() => {
    if (
      dueTotal === undefined ||
      dueTotal <= 0 ||
      surchargePercentage === undefined
    ) {
      return dueTotal
    }
    return roundToTwoDecimal(dueTotal + (dueTotal * surchargePercentage) / 100)
  }, [dueTotal, surchargePercentage])

  return (
    <Fragment>
      <PaymentDialogUI
        payments={activeCounterSale?.pricing?.payments || []}
        dueTotal={dueTotal}
        dueTotalWithSurcharge={dueTotalWithSurcharge}
        surchargePercentage={surchargePercentage}
        openFinixDialog={openFinixDialog}
        setOpenFinixDialog={setOpenFinixDialog}
        isSubmittingCardPresent={isSubmittingCardPresent}
        setIsSubmittingCardPresent={setIsSubmittingCardPresent}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button color="inherit" onClick={handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button color="inherit" onClick={handleNext} sx={{ mr: 1 }}>
          Next
        </Button>
      </Box>
    </Fragment>
  )
}

export default CounterSalePayment
